module.exports = __webpack_public_path__ + "static/gif1.783677fd.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/dtgif/gif1.gif
// module id = 539
// module chunks = 270958380025928